import { ListaAtividadeDTO } from "app/main/a2w/gestor/paineis/atividades-graficos/models/analise-atividades.model";

export class DashboardAtividade {

    public static dataSource: [
    {
      "idAtividade": 137,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "SHINIKO-IZZA DO BRASIL PEÇAS AUTOMOTIVAS LTDA",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 9
    },
    {
      "idAtividade": 138,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "SHINIKO-IZZA DO BRASIL PEÇAS AUTOMOTIVAS LTDA",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 139,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "SHINIKO-IZZA DO BRASIL PEÇAS AUTOMOTIVAS LTDA",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 30,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 140,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "PAULO CESAR FERREIRA - ME",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 7,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 141,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "MARIA DA SILVA",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 142,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 143,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 145,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 24704,
      "nmCliente": "ANTONIO GERALDO DO PRADO",
      "idVendedor": 2,
      "nmVendedor": "A2W",
      "idCultura": 8,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 146,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 20,
      "nmCliente": "ALEX SANTOS GABRIEL",
      "idVendedor": 2,
      "nmVendedor": "A2W",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 147,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 4420,
      "nmCliente": "FRANCISCO MARCELO DE OLIVEIRA",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 148,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 4420,
      "nmCliente": "FRANCISCO MARCELO DE OLIVEIRA",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 149,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2003,
      "nmCliente": "LUIZ CARLOS DE LIMA E OUTROS",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 150,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 9014,
      "nmCliente": "LUIZ CARLOS MARCON",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 3
    },
    {
      "idAtividade": 151,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 575,
      "nmCliente": "ALEXSANDRO CARLOS FILHO",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 3
    },
    {
      "idAtividade": 153,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 14198,
      "nmCliente": "HUGO BUSTAMANTE MONTI",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 154,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 155,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 156,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 3
    },
    {
      "idAtividade": 157,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 23393,
      "nmCliente": "GERALDO ALVES DA SILVA",
      "idVendedor": 2,
      "nmVendedor": "A2W",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 158,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 3
    },
    {
      "idAtividade": 159,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 160,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 161,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "MARIA DA SILVA",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 162,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "MARIA DA SILVA",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 8,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 9
    },
    {
      "idAtividade": 163,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "MARIA DA SILVA",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 164,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "MARIA DA SILVA",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 9,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 166,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 7,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 167,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 7,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 168,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2,
      "nmCliente": "MARIA DA SILVA",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 169,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1,
      "nmCliente": "JOAO DA SILVA LOPES",
      "idVendedor": 1,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 170,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 436,
      "nmCliente": "JOAO CARLOS DA SILVA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 7,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 171,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 1350,
      "nmCliente": "BRUNO LEONARDO FERREIRA FRANCO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 9,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 172,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 485,
      "nmCliente": "JOAO BRAZ DE OLIVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 173,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2363,
      "nmCliente": "ANTONIO JOSE FAGUNDES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 8,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 174,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 10313,
      "nmCliente": "LUIZ AECIO SIQUEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 175,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 15799,
      "nmCliente": "ADRIELY FERREIRA DE BRITO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 176,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2205,
      "nmCliente": "BENEDITO DUARTE",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 177,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 19702,
      "nmCliente": "SAMUEL GUILHERME PEREIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 178,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 2205,
      "nmCliente": "BENEDITO DUARTE",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 179,
      "dtLancamento": "2020-12-28T08:53:35.997",
      "idCliente": 14094,
      "nmCliente": "ALEXANDRE GODINHO SANTOS",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 9,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 180,
      "dtLancamento": "2020-12-29T15:07:02.393",
      "idCliente": 4248,
      "nmCliente": "ADILSON EZEQUIEL DO COUTO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 181,
      "dtLancamento": "2020-12-29T18:18:37.657",
      "idCliente": 4248,
      "nmCliente": "ADILSON EZEQUIEL DO COUTO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 182,
      "dtLancamento": "2020-12-29T18:23:25.157",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 183,
      "dtLancamento": "2020-12-29T18:28:03.593",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 184,
      "dtLancamento": "2020-12-29T18:35:19.627",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 185,
      "dtLancamento": "2021-02-19T01:02:58.5",
      "idCliente": 106743,
      "nmCliente": "ALVARO MATEUS RIBEIRO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 10,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 186,
      "dtLancamento": "2021-02-25T15:01:23.903",
      "idCliente": 7396,
      "nmCliente": "MARCELO FERNANDO CAMPOS",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 187,
      "dtLancamento": "2021-03-10T23:42:50.92",
      "idCliente": 14094,
      "nmCliente": "ALEXANDRE GODINHO SANTOS",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 6,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 188,
      "dtLancamento": "2021-03-12T19:15:29.1",
      "idCliente": 1533,
      "nmCliente": "ADALTON RODRIGO GOULART",
      "idVendedor": 48,
      "nmVendedor": "CLAUDINEI FERREIRA DA ",
      "idCultura": 6,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 2
    },
    {
      "idAtividade": 189,
      "dtLancamento": "2021-03-12T14:23:17.273",
      "idCliente": 12921,
      "nmCliente": "ABEL FONSECA CAMARGO",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 2,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 190,
      "dtLancamento": "2021-03-12T18:24:26.67",
      "idCliente": 18276,
      "nmCliente": "ALCIDIO BASSO",
      "idVendedor": -1,
      "nmVendedor": "Matheus",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 191,
      "dtLancamento": "2021-03-12T15:20:38.033",
      "idCliente": 5452,
      "nmCliente": "ARTUR CAMILOTTI FILHO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 7,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 192,
      "dtLancamento": "2021-03-12T15:28:06.517",
      "idCliente": 2626,
      "nmCliente": "ALTAMIR RIBEIRO TEIXEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 7,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 193,
      "dtLancamento": "2021-03-12T15:37:34.577",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 194,
      "dtLancamento": "2021-03-12T16:32:15.957",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 9
    },
    {
      "idAtividade": 195,
      "dtLancamento": "2021-03-12T17:00:31.907",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 196,
      "dtLancamento": "2021-03-15T00:04:30.667",
      "idCliente": 15819,
      "nmCliente": "LUCAS ALEXANDRE RODRIGUES BORGES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 14,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 197,
      "dtLancamento": "2021-03-15T00:07:08.623",
      "idCliente": 10601,
      "nmCliente": "PEDRO CELIO GALDINO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 11,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 198,
      "dtLancamento": "2021-03-15T17:46:56.88",
      "idCliente": 9490,
      "nmCliente": "CLAUDIO ROBERTO ARANTES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 13,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 202,
      "dtLancamento": "2021-03-15T17:49:29.343",
      "idCliente": 9393,
      "nmCliente": "LUIS FLAVIO MENDES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 14,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 204,
      "dtLancamento": "2021-03-15T17:51:20.38",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 205,
      "dtLancamento": "2021-03-15T18:16:40.34",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 206,
      "dtLancamento": "2021-03-16T00:44:55.3",
      "idCliente": 1443,
      "nmCliente": "LUCAS FRANCO SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 8,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 207,
      "dtLancamento": "2021-04-09T19:45:35.65",
      "idCliente": 457,
      "nmCliente": "JESUEL PEDRO",
      "idVendedor": 0,
      "nmVendedor": "",
      "idCultura": 2,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 2
    },
    {
      "idAtividade": 208,
      "dtLancamento": "2021-04-23T11:12:58.907",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 70,
      "tipoAtividade": "Funciona 2",
      "idStatus": 1
    },
    {
      "idAtividade": 209,
      "dtLancamento": "2021-04-23T11:18:27.98",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 71,
      "tipoAtividade": "Teste2",
      "idStatus": 1
    },
    {
      "idAtividade": 210,
      "dtLancamento": "2021-04-23T09:45:26.397",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 211,
      "dtLancamento": "2021-04-23T09:48:41.007",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 212,
      "dtLancamento": "2021-04-23T13:05:54.06",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 213,
      "dtLancamento": "2021-04-23T13:33:38.29",
      "idCliente": 457,
      "nmCliente": "JESUEL PEDRO",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 2,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 2
    },
    {
      "idAtividade": 214,
      "dtLancamento": "2021-04-23T18:33:58.353",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 215,
      "dtLancamento": "2021-04-23T19:21:57.343",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 14,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 216,
      "dtLancamento": "2021-04-26T16:09:56.67",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 72,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 217,
      "dtLancamento": "2021-04-26T14:15:18.783",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 3,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 218,
      "dtLancamento": "2021-04-26T18:57:56.07",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 75,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 219,
      "dtLancamento": "2021-04-26T19:00:26.96",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 76,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 220,
      "dtLancamento": "2021-04-27T10:25:12.173",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 221,
      "dtLancamento": "2021-04-27T17:03:17.197",
      "idCliente": 497,
      "nmCliente": "HELIODERIO MARCOS MACHADO",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 4,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 222,
      "dtLancamento": "2021-04-29T19:04:11.81",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 87,
      "tipoAtividade": "editado",
      "idStatus": 1
    },
    {
      "idAtividade": 223,
      "dtLancamento": "2021-04-30T11:55:40.91",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 88,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 224,
      "dtLancamento": "2021-04-30T14:31:35.53",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 1,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 225,
      "dtLancamento": "2021-04-30T14:34:25.197",
      "idCliente": 13422,
      "nmCliente": "ADAILSON LOPES DA SILVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 226,
      "dtLancamento": "2021-04-30T17:22:21.99",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 91,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 227,
      "dtLancamento": "2021-04-30T17:33:54.32",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 92,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 228,
      "dtLancamento": "2021-04-30T17:43:56.997",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 93,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 229,
      "dtLancamento": "2021-04-30T17:43:56.997",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 94,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 230,
      "dtLancamento": "2021-04-30T17:56:27.493",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 95,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 231,
      "dtLancamento": "2021-04-30T17:59:08.597",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 96,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 232,
      "dtLancamento": "2021-04-30T18:12:52.787",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 97,
      "tipoAtividade": "string",
      "idStatus": 1
    },
    {
      "idAtividade": 234,
      "dtLancamento": "2021-04-30T18:16:24.88",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 2,
      "tipoAtividade": "Visita Comercial",
      "idStatus": 1
    },
    {
      "idAtividade": 235,
      "dtLancamento": "2021-04-30T18:59:01.727",
      "idCliente": 137,
      "nmCliente": "PEDRO BOCATER SZENESZI",
      "idVendedor": 1,
      "nmVendedor": "JACUHY AGRONEGOCIOS LTDA",
      "idCultura": 4,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 239,
      "dtLancamento": "2021-05-07T19:02:27.507",
      "idCliente": 17577,
      "nmCliente": "JOSE VITOR PEDRO E OUTROS",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 0,
      "tipoCultura": "",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 240,
      "dtLancamento": "2021-05-13T19:33:21.02",
      "idCliente": 2363,
      "nmCliente": "ANTONIO JOSE FAGUNDES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 26,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 241,
      "dtLancamento": "2021-05-13T19:34:43.95",
      "idCliente": 2363,
      "nmCliente": "ANTONIO JOSE FAGUNDES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 26,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 242,
      "dtLancamento": "2021-05-13T19:36:01.637",
      "idCliente": 2363,
      "nmCliente": "ANTONIO JOSE FAGUNDES",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 26,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    },
    {
      "idAtividade": 243,
      "dtLancamento": "2021-05-17T19:42:45.677",
      "idCliente": 485,
      "nmCliente": "JOAO BRAZ DE OLIVEIRA",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 16,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 3
    },
    {
      "idAtividade": 248,
      "dtLancamento": "2021-05-19T16:28:46.87",
      "idCliente": 0,
      "nmCliente": "string",
      "idVendedor": 0,
      "nmVendedor": "string",
      "idCultura": 0,
      "tipoCultura": "string",
      "idTipoAtividade": 3,
      "tipoAtividade": "Ligação",
      "idStatus": 1
    },
    {
      "idAtividade": 249,
      "dtLancamento": "2021-05-20T17:27:47.367",
      "idCliente": 6102,
      "nmCliente": "EVERTON JOSE DE CARVALHO",
      "idVendedor": 142,
      "nmVendedor": "Prover",
      "idCultura": 4,
      "tipoCultura": "",
      "idTipoAtividade": 1,
      "tipoAtividade": "Visita Técnica",
      "idStatus": 1
    }
  ]
}